import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { DialogData } from '@app/shared/models/dialog-data';
import { ConfirmationType } from '@app/shared/types';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'tc-video-dialog',
    templateUrl: './video-dialog.component.html',
    styleUrls: ['./video-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class VideoDialogComponent {

  dialogData: DialogData;
  itemToDelete: string;
  confirmationType = ConfirmationType;
  url: string;
  poster: string;

  constructor(
    private dialogRef: MatDialogRef<VideoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.url = data.url;
    this.poster = data.poster;
  }



  public close(): void {
    this.dialogRef.close();
  }

}
